import {FlowMeterType, flowMeterType as flowType, isDatabaseCode, MeterType, meterType} from "@ots-frontend/ots-data";
import {Group, Indicator} from "@mantine/core";
import {EntityIcon} from "../../../icon/EntityIcon/EntityIcon";
import {EntityAnchor} from "../../../anchor/EntityAnchor/EntityAnchor";

export type MeterCellProps = {
  meterId: string
  meterName?: string
  type?: string | MeterType
  flowMeterType?: string | FlowMeterType,
}

export const MeterCell = (props: MeterCellProps) => {
  const {meterId, meterName, type, flowMeterType} = props

  let showIndicator = false

  if (type && flowMeterType) {
    const typeCode = isDatabaseCode(type) ? type.code : type
    const flowTypeCode = isDatabaseCode(flowMeterType) ? flowMeterType.code : flowMeterType
    showIndicator = typeCode === meterType.flow.code && flowTypeCode === flowType.check.code
  }

  if (showIndicator) {
    return (
      <Indicator inline size={6} color="orange">
        <Group spacing="xs">
          <EntityIcon
            entityType="METER"
            size="0.9em"
          />
          <EntityAnchor
            value={{
              objectId: meterId,
              objectName: meterName,
              objectType: "METER"
            }}
          />
        </Group>
      </Indicator>
    )
  } else {
    return (
      <Group spacing="xs">
        <EntityIcon
          entityType="METER"
          size="0.9em"
        />
        <EntityAnchor
          value={{
            objectId: meterId,
            objectName: meterName,
            objectType: "METER"
          }}
        />
      </Group>
    )
  }
}
